/*
 * @Desc:
 * @Author: JacksonZhou
 * @Date: 2021/12/12
 * @LastEditTime: 2021/12/12
 */
export const INVALID_DATE = "Invalid date";
